import React, { useEffect, useState } from 'react';
import SearchBar from './SearchBar';
import styled from 'styled-components';
import BrandSelector from './BrandSelector';
import ArticleList from './ArticleList';
import { fetchNewsfeed } from '../../requests/newsfeed';
import { getItem } from '../../utils/localStorage';
import LoadingContent from 'lqa-ui/lib/Components/LoadingContent';
import AccessDenied from '../AccessDenied';
import {
  getBrandAndHotelData,
  gethasAssessment,
} from '../../helpers/handleBrandAndHotelData';
import { AppHeader } from '../../app/common/sharedComponents/AppHeader';
import { useTranslation } from 'react-i18next';
import { HeaderContainer } from './../../app/common/sharedStyledComponents/GenericStyles.styled';

const Wrapper = styled.div`
  margin-bottom: 88px;
`;

const Content = styled.div`
  padding: 15px 0;
  margin-top: 180px;
`;

const SearchBarWrapper = styled.div`
  margin: 16px 0 24px;
`;

type FilterBy = 'hotel' | 'brand';

const Newsfeed = () => {
  const [q, setQ] = useState<string>('');
  const [filterBy, setFilterBy] = useState<FilterBy>('hotel');
  const [selectedBarItem, setSelectedBarItem] = useState({
    hotel: true,
    brand: false,
  });
  const userData = getItem('user');
  const { t } = useTranslation();

  const onFilterChangeHandler = async (selectedFilter: any) => {
    if (selectedFilter === filterBy) {
      return;
    }
    setFilterBy(selectedFilter);
    setIsLoading(true);
    setData([]);
    setHasMore(true);
    setPageNumber(1);
    fetchNewsFeedHandler(1, selectedFilter);
    setSelectedBarItem({
      hotel: false,
      brand: false,
      [selectedFilter]: true,
    });
  };

  const [data, setData]: any = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedCategoryId, setSelectedCategoryId] = useState<
    number | undefined
  >(undefined);
  const [selectedUserId, setSelectedUserId] = useState<number | undefined>(
    undefined
  );
  const hasAssessment = gethasAssessment();
  const allHotels = getBrandAndHotelData();

  const fetchNewsFeedHandler = async (
    page = pageNumber,
    selectedFilter = filterBy,
    categoryId = selectedCategoryId,
    userId = selectedUserId,
    dueDateStart = '',
    dueDateEnd = ''
  ) => {
    try {
      const responseData = await fetchNewsfeed(
        q,
        selectedFilter,
        page,
        categoryId,
        userId,
        dueDateStart,
        dueDateEnd
      );

      if (page !== 1) {
        setData((prevData) => [...prevData, ...responseData.results]);
      } else {
        setData((prevData) => [...responseData.results]);
      }
      if (responseData.numberOfPages <= page) {
        setHasMore(false);
      } else {
        setHasMore(true);
        setPageNumber((p) => p + 1);
      }
      setIsLoading(false);
      return responseData;
    } catch (err) {}
  };

  useEffect(() => {
    if (hasAssessment) {
      setIsLoading(true);
      setData([]);
      setHasMore(true);
      setPageNumber(1);
      fetchNewsFeedHandler(1);
    }
  }, []);

  if (!userData || !userData.user || allHotels.length <= 0) {
    return (
      <>
        <AccessDenied tabname="Newsfeed" />
      </>
    );
  }

  const handleSearch = () => {
    setPageNumber(1);
    fetchNewsFeedHandler(1);
  };
  return (
    <Wrapper>
      <HeaderContainer>
        <AppHeader
          title={t('COMMON.NEWSFEED.TITLES.NEWSFEED')}
          hasBackButton={false}
        >
          <SearchBarWrapper>
            <SearchBar setSearchInput={setQ} onSearchHandler={handleSearch} />
          </SearchBarWrapper>
        </AppHeader>
      </HeaderContainer>
      <Content>
        <BrandSelector
          onChangeHandler={onFilterChangeHandler}
          selectedBarItem={selectedBarItem}
        />
        {isLoading ? (
          <div className="mt-20">
            <LoadingContent layout="flex" />
          </div>
        ) : (
          <ArticleList
            data={data}
            fetchNewsFeedHandler={fetchNewsFeedHandler}
            hasMore={hasMore}
          />
        )}
      </Content>
    </Wrapper>
  );
};

export default Newsfeed;
